/**
 * If an existing value changes here, check if third parties use that value. If so: either inform those third parties
 * or do not change the value. Preference is not changing it.
 */
enum InterestUri {
    FixedPeriod = 'rentevast-periode',
    MarketValue = 'marktwaarde',
    Product = 'product',
    PropertiesPerLabel = 'hypotheekvoorwaarden-per-product',
    PropertiesPerProperty = 'hypotheekvoorwaarden',
    InterestNews = 'nieuws',
    BridgingLoan = 'overbruggingskrediet',
    PropertiesNews = 'hypotheekvoorwaarden-nieuws',
}

export default InterestUri;
